import React from "react";
import PropTypes from "prop-types";
import { idPropType } from "components/propTypes";
import RtrImage from "../shared/rtr-image";
import { displayModal } from "actions/shared-actions";
import reviewsActions from "actions/reviews-actions";
import { connect } from "react-redux";
import { setReviewModalReviewId, setReviewModalOpen } from "slices/pdp-slice";

export class ReviewPhoto extends React.Component {
  static propTypes = {
    coverPhotoId: PropTypes.number.isRequired,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photoId: PropTypes.number,
      })
    ).isRequired,
    reviewId: idPropType,
    useNewModal: PropTypes.bool,
    displayReviewPhotosModal: PropTypes.func,
    displayNewReviewPhotosModal: PropTypes.func,
    openSpecificReviewPhoto: PropTypes.func,
  };

  triggerMomentLightBox = () => {
    if (this.props.useNewModal) {
      this.props.displayNewReviewPhotosModal(this.props.reviewId);
    } else {
      this.props.openSpecificReviewPhoto(this.props.reviewId);
      this.props.displayReviewPhotosModal();
    }
  };

  coverPhoto = this.props.photos?.find(photo => photo?.photoId === this.props.coverPhotoId);

  render() {
    let reviewImage;

    if (this.coverPhoto?.urls?.imageLargeThumb) {
      reviewImage = <RtrImage src={this.coverPhoto.urls.imageLargeThumb} alt="" />;
    }

    return (
      <div className="review-moment">
        {reviewImage}
        <button
          className="review-moment-overlay title"
          data-test-id="review-photo-image-clickable"
          onClick={this.triggerMomentLightBox}>
          <span>{"View photos (" + this.props.photos.length + ")"}</span>
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    displayNewReviewPhotosModal: reviewId => {
      dispatch(setReviewModalOpen(true));
      dispatch(setReviewModalReviewId(reviewId));
    },
    displayReviewPhotosModal: () => {
      dispatch(displayModal("REVIEW_PHOTOS"));
    },
    dismissModal: () => {
      dispatch(displayModal(false));
    },
    openSpecificReviewPhoto: i => {
      dispatch(reviewsActions.openSpecificReviewPhoto(i));
    },
  };
};

export default connect(null, mapDispatchToProps)(ReviewPhoto);
